import type {
  ProposeDeliveryNoteAssignmentMutationOptions,
  ProposeDeliveryNoteAssignmentVariables,
} from './types';

import { useMutation } from '@tanstack/react-query';

import { proposeDeliveryNoteAssignment } from './proposeDeliveryNoteAssignment';

/**
 * React Query based custom hook for requesting the delivery note assignment proposal of an invoice.
 * It invalidates nothing, and the caller reports failures itself.
 *
 * @param options - Additional options for the useMutation hook.
 * @returns The result of the useMutation hook.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Invoices
 */
export function useMutationProposeDeliveryNoteAssignment(
  options?: ProposeDeliveryNoteAssignmentMutationOptions,
) {
  return useMutation({
    ...options,
    meta: { ...options?.meta, suppressError: true },
    mutationFn: (variables: ProposeDeliveryNoteAssignmentVariables) =>
      proposeDeliveryNoteAssignment(variables),
  });
}
